import { getApp } from "firebase/app"
import { getStorage, type FirebaseStorage } from "firebase/storage"

let storage: FirebaseStorage | null = null

/** Lazy-init Storage (bucket from firebaseConfig storageBucket). */
export const getFirebaseStorage = (): FirebaseStorage => {
  if (!storage) storage = getStorage(getApp())
  return storage
}
